// Vue
import { Vue, Component, Prop } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Components
import ModuleWrapper from "../../../../components/module_wrapper/ModuleWrapper";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class ProductPartnerAdvantagesImplModule extends Vue {
  @Prop({ default: "white" })
  public backgroundColor!: string;

  @Prop({ default: null })
  public partnerAdvantages!: object | null;

  @Prop({ default: null })
  public modelAdvantages!: object | null;

  @Prop()
  public instance!: object;

  private isPartnerAdvantagesOpen = false;
  private isModelAdvantagesOpen = false;

  public onOpenPartnerAdvantages() {
    this.isPartnerAdvantagesOpen = !this.isPartnerAdvantagesOpen;
  }

  public onOpenModelAdvantages() {
    this.isModelAdvantagesOpen = !this.isModelAdvantagesOpen;
  }
}
